// Account status badge — FE-038.

import type { AccountListRow } from "./types";


const META: Record<AccountListRow["status"], { label: string; classes: string }> = {
  active: {
    label: "Active",
    classes: "bg-sage-tint text-teal",
  },
  archived: {
    label: "Archived",
    classes: "bg-recessed text-text-secondary",
  },
};


export function AccountStatusBadge({
  status,
}: { status: AccountListRow["status"] }) {
  const meta = META[status];
  return (
    <span
      data-testid={`account-status-badge-${status}`}
      data-status={status}
      className={[
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        meta.classes,
      ].join(" ")}
    >
      {meta.label}
    </span>
  );
}
